export const PATIENT_WORKFLOW_PERMISSIONS = Object.freeze({
  retrieve: 'clients:get',
  create: 'clients:create',
  update: 'clients:update'
});

export const PATIENT_WORKFLOW_PERMISSION_OPTIONS = Object.freeze([
  {
    value: PATIENT_WORKFLOW_PERMISSIONS.retrieve,
    label: 'Retrieve Patient Info',
    description: 'Look up and review patient records.'
  },
  {
    value: PATIENT_WORKFLOW_PERMISSIONS.create,
    label: 'Add Patient',
    description: 'Create new patient records.'
  },
  {
    value: PATIENT_WORKFLOW_PERMISSIONS.update,
    label: 'Update Patient',
    description: 'Prepare and confirm changes to patient records.'
  }
]);

export function canRetrievePatients(permissions = []) {
  return permissions.includes('*') || permissions.includes(PATIENT_WORKFLOW_PERMISSIONS.retrieve);
}

export function canCreatePatients(permissions = []) {
  return permissions.includes('*') || permissions.includes(PATIENT_WORKFLOW_PERMISSIONS.create);
}

export function canUpdatePatients(permissions = []) {
  return permissions.includes('*') || permissions.includes(PATIENT_WORKFLOW_PERMISSIONS.update);
}

export function canArchivePatients(permissions = []) {
  return false;
}

export function getPatientWorkflowAccess(permissions = []) {
  return {
    canRetrieve: canRetrievePatients(permissions),
    canCreate: canCreatePatients(permissions),
    canUpdate: canUpdatePatients(permissions),
    canArchive: canArchivePatients(permissions)
  };
}

export const ORDERS_WORKFLOW_PERMISSIONS = Object.freeze({
  retrieve: 'orders:get',
  create: 'orders:create',
  update: 'orders:update',
  archive: 'orders:delete',
  bulkUpdate: 'orders:bulk_update'
});

export const ORDERS_WORKFLOW_PERMISSION_OPTIONS = Object.freeze([
  {
    value: ORDERS_WORKFLOW_PERMISSIONS.retrieve,
    label: 'Retrieve Order Info',
    description: 'Look up and view order records'
  },
  {
    value: ORDERS_WORKFLOW_PERMISSIONS.create,
    label: 'Create Order',
    description: 'Create new order records'
  },
  {
    value: ORDERS_WORKFLOW_PERMISSIONS.update,
    label: 'Update Order',
    description: 'Modify existing order records'
  },
  {
    value: ORDERS_WORKFLOW_PERMISSIONS.archive,
    label: 'Archive Order',
    description: 'Archive/remove order records'
  },
  {
    value: ORDERS_WORKFLOW_PERMISSIONS.bulkUpdate,
    label: 'Bulk Update Orders',
    description: 'Apply type/status changes to many orders at once (admin-only).'
  }
]);

export function canRetrieveOrders(permissions = []) {
  return permissions.includes('*') || permissions.includes(ORDERS_WORKFLOW_PERMISSIONS.retrieve);
}

export function canCreateOrders(permissions = []) {
  return permissions.includes('*') || permissions.includes(ORDERS_WORKFLOW_PERMISSIONS.create);
}

export function canUpdateOrders(permissions = []) {
  return permissions.includes('*') || permissions.includes(ORDERS_WORKFLOW_PERMISSIONS.update);
}

export function canArchiveOrders(permissions = []) {
  return permissions.includes('*') || permissions.includes(ORDERS_WORKFLOW_PERMISSIONS.archive);
}

export function canBulkUpdateOrders(permissions = []) {
  return permissions.includes('*') || permissions.includes(ORDERS_WORKFLOW_PERMISSIONS.bulkUpdate);
}

export function getOrdersWorkflowAccess(permissions = []) {
  return {
    canRetrieve: canRetrieveOrders(permissions),
    canCreate: canCreateOrders(permissions),
    canUpdate: canUpdateOrders(permissions),
    canArchive: canArchiveOrders(permissions),
    canBulkUpdate: canBulkUpdateOrders(permissions)
  };
}
